import React from 'react'

const PostSkeleton = () => {
    return (
        <div className="grid 2xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3">
            <div className="bg-gray rounded-md overflow-hidden aspect-square relative animate-pulse w-full h-full"></div>
            <div className="bg-gray rounded-md overflow-hidden aspect-square relative animate-pulse w-full h-full"></div>
            <div className="bg-gray rounded-md overflow-hidden aspect-square relative animate-pulse w-full h-full"></div>
            <div className="bg-gray rounded-md overflow-hidden aspect-square relative animate-pulse w-full h-full"></div>
            <div className="bg-gray rounded-md overflow-hidden aspect-square relative animate-pulse w-full h-full"></div>
            <div className="bg-gray rounded-md overflow-hidden aspect-square relative animate-pulse w-full h-full"></div>
        </div>
    )
}

export default PostSkeleton
